import { render } from "./ScoreManageDialog.vue?vue&type=template&id=5e100e72&scoped=true"
import script from "./ScoreManageDialog.vue?vue&type=script&lang=js"
export * from "./ScoreManageDialog.vue?vue&type=script&lang=js"

import "./ScoreManageDialog.vue?vue&type=style&index=0&id=5e100e72&scoped=true&lang=css"

import exportComponent from "E:\\html\\yiban-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e100e72"]])

export default __exports__